<template>
  <div
    v-if="!isAppoinmentMode"
    class="tabs-filter-container order-0"
    role="group"
    aria-label="Dashboard pass status filters"
  >
    <button
      type="button"
      class="filter-tab d-flex justify-content-center align-items-center text-center"
      :class="{ active: activePassState === 'active' }"
      data-test-id="dashboard-active-passes-tab"
      :aria-pressed="activePassState === 'active' ? 'true' : 'false'"
      @click="setActivePassState('active')"
    >
      <span class="filter-tab-content">Active</span>
    </button>
    <button
      v-if="shouldShowBothTab"
      class="filter-tab d-flex justify-content-center align-items-center text-center"
      :class="{ active: activePassState === 'both' }"
      data-test-id="dashboard-both-passes-tab"
      type="button"
      :aria-pressed="activePassState === 'both' ? 'true' : 'false'"
      @click="setActivePassState('both')"
    >
      <span class="filter-tab-content">Active & Ended</span>
    </button>
    <button
      v-if="shouldShowEndedTab"
      class="filter-tab d-flex justify-content-center align-items-center text-center"
      :class="{ active: activePassState === 'ended' }"
      data-test-id="dashboard-ended-passes-tab"
      type="button"
      :aria-pressed="activePassState === 'ended' ? 'true' : 'false'"
      @click="setActivePassState('ended')"
    >
      <span class="filter-tab-content">Ended</span>
    </button>
    <button
      v-if="shouldShowQueueTab"
      class="filter-tab d-flex justify-content-center align-items-center text-center"
      :class="{ active: activePassState === 'queue' }"
      data-test-id="dashboard-queue-passes-tab"
      type="button"
      :aria-pressed="activePassState === 'queue' ? 'true' : 'false'"
      @click="setActivePassState('queue')"
    >
      <span class="filter-tab-content">Queue</span>
    </button>
  </div>
</template>

<script>
import { computed } from "vue"
import { useStore } from "vuex"

export default {
  name: "DashboardStatusFiltersOld",
  setup() {
    const store = useStore()

    const activePassType = computed(
      () => store.getters["dashboardTable/getType"]
    )

    const activePassState = computed(
      () => store.getters["dashboardTable/getStatus"]
    )

    const isUserInTransparency = computed(
      () => store.getters["authentication/isUserInTransparency"]
    )

    const isAppoinmentMode = computed(() => {
      return activePassType.value.includes("appointment")
    })

    const shouldShowBothTab = computed(() => {
      return activePassType.value !== "all" || isUserInTransparency.value
    })

    const shouldShowEndedTab = computed(() => {
      return activePassType.value !== "all" || isUserInTransparency.value
    })

    const isQueueModuleActive = computed(() => {
      return store.getters["queueSettings/isQueueModuleActive"]
    })

    const shouldShowQueueTab = computed(() => {
      return isQueueModuleActive.value
    })

    const setActivePassState = (status) => {
      store.commit("dashboardTable/UPDATE_STATUS", status)
    }

    return {
      activePassState,
      isAppoinmentMode,
      shouldShowBothTab,
      shouldShowEndedTab,
      shouldShowQueueTab,
      setActivePassState
    }
  }
}
</script>

<style scoped>
@import "@/assets/scss/_variables.scss";

.filter-tab {
  border: 0;
  background: transparent;

  &:focus-visible {
    outline: 2px solid $outline-color;
    outline-offset: $outline-offset;
  }
}

.filter-tab-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  font-size: 12px;
}
</style>
